import { apiUrl, currentUserId, currentUserQuery } from "./auth";

export type DayPart = "morning" | "afternoon" | "day";

export const DAY_BLOCK_PARTS: Array<{ id: DayPart; label: string; hours: string; note?: string }> = [
  { id: "morning", label: "Matin", hours: "8 h 30 – 12 h 30" },
  { id: "afternoon", label: "Après-midi", hours: "14 h 30 – 18 h" },
  { id: "day", label: "Journée", hours: "8 h 30 – 18 h", note: "pause comprise" },
];

export type DayBlockPack = {
  linked: boolean;
  ready: boolean;
  days: Record<string, DayPart[]>;
};

function headers(): HeadersInit {
  const id = currentUserId();
  return { ...(id ? { "X-User-Id": id } : {}), "Content-Type": "application/json" };
}

async function read(res: Response): Promise<Record<string, unknown>> {
  const data = (await res.json().catch(() => ({}))) as Record<string, unknown>;
  if (!res.ok || data.success === false) {
    throw new Error(String(data.message || "L’agenda n’a pas enregistré le blocage."));
  }
  return data;
}

function partsOf(value: unknown): DayPart[] {
  if (!Array.isArray(value)) return [];
  return DAY_BLOCK_PARTS.map((row) => row.id).filter((id) => value.includes(id));
}

export async function loadDayBlocks(from: string, to: string): Promise<DayBlockPack> {
  const query = new URLSearchParams({ from, to });
  const extra = currentUserQuery();
  const join = extra ? `${extra}&` : "?";
  const res = await fetch(`${apiUrl("day-block.php")}${join}${query.toString()}`, {
    credentials: "include",
    cache: "no-store",
    headers: headers(),
  });
  const data = await read(res);
  const raw = data.days && typeof data.days === "object" ? data.days as Record<string, unknown> : {};
  const days: Record<string, DayPart[]> = {};
  for (const [day, value] of Object.entries(raw)) days[day] = partsOf(value);
  return { linked: data.linked !== false, ready: data.ready !== false, days };
}

export async function setDayBlock(day: string, part: DayPart, on: boolean): Promise<{ linked: boolean; ready: boolean; parts: DayPart[] }> {
  const res = await fetch(apiUrl("day-block.php") + currentUserQuery(), {
    method: "POST",
    credentials: "include",
    cache: "no-store",
    headers: headers(),
    body: JSON.stringify({ day, part, on }),
  });
  const data = await read(res);
  return { linked: data.linked !== false, ready: data.ready !== false, parts: partsOf(data.parts) };
}
